export function stripZipCodeMask(masked: string): string {
  return masked.replace(/\D/g, '');
}

export function applyZipCodeMask(value: string): string {
  const digits = stripZipCodeMask(value).slice(0, 8);

  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
